<template>
    <div class="bg-gray relative z-0" >
        <div class="page-container page-container--left-white ">
            <div class="p-0 lg:p-5">
                <h1 class="mb-10 px-5 lg:px-0">
                    Profile
                </h1>

                <div class="grid grid-cols-1 lg:grid-cols-2 order-last" >
                    <div class="bg-gray md:bg-white px-5 py-0 lg:bg-transparent lg:pr-20 lg:pl-0 ">
                        <div class="mb-3">
                            <a class="btn btn--white w-full text-left mb-3 justify-start" :class="{active: openMode == 'profile'}" @click="openProfile">
                                <i class="fas fa-pencil mr-3 text-xl"></i> Update User Profile </a>
                        </div>

                        <div class="mb-3">
                            <a class="btn btn--white w-full text-left mb-3 justify-start" :class="{active: openMode == 'password'}" @click="openPassword">
                                <i class="fas fa-lock mr-3 text-xl"></i> Change Password </a>
                        </div>

                        <div class="mb-3">
                            <a class="btn btn--white w-full text-left mb-3 justify-start" :class="{active: openMode == 'auth'}" @click="openAuthenticate">
                                <i class="fas fa-shield-check mr-3 text-xl"></i> 2FA Security</a>
                        </div>

                        <div class="mb-3">
                            <router-link
                                    :to="{ name: 'signOut' }"
                                    class="btn btn--white w-full text-left mb-3 justify-start">
                                <i class="fas fa-sign-out mr-3 text-xl"></i> Sign Out
                            </router-link>
                        </div>
                    </div>


                    <div class="px-5 lg:px-20 py-10 lg:py-0 mb-8 lg:ml-auto mr-auto lg:mx-0 w-full ">
                        <profile-form v-if="openMode == 'profile'"
                                      @submit-success="onSuccess"
                        ></profile-form>

                        <password-form
                                v-if="openMode == 'password'"
                                @submit-success="onSuccess"></password-form>
                        <tfa-form
                                v-if="openMode == 'auth'"
                                @submit-success="onSuccess"></tfa-form>
                    </div>

                </div>
            </div>
        </div>
    </div>


</template>

<script charset="utf-8">

import ProfileForm from './form/ProfileForm.vue';
import PasswordForm from './form/PasswordForm.vue';
import TfaForm from './form/TfaForm.vue';
import Vuex from 'vuex';


export default {
    name: 'Profile',

    props: [],

    data() {
        return {
            success: false,
            openMode: ''
        }
    },

    components: {
        ProfileForm,
        PasswordForm,
        TfaForm
    },

    computed: {
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
    },

    methods: {
        onSuccess(value){
            this.success = true;
        },
        openProfile(){
            this.openMode = 'profile';
        },
        openPassword(){
            this.openMode = 'password';
        },
        openAuthenticate(){
            this.openMode = 'auth';
        }
    },
}
</script>
